import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricValuesPlot',
  props: {
    metricAssignment: {
      type: Object,
      required: true
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var chartOptions = computed(function () {
      var _props$metricAssignme, _props$metricAssignme2;
      return {
        chart: {
          type: 'line',
          stacked: false,
          animations: {
            enabled: false
          },
          id: 'vuechart-example',
          height: 300
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          tooltip: {
            enabled: false
          }
        },
        yaxis: {
          type: 'numeric',
          title: {
            style: {
              fontSize: '14px'
            },
            text: (_props$metricAssignme = props.metricAssignment) === null || _props$metricAssignme === void 0 ? void 0 : (_props$metricAssignme2 = _props$metricAssignme.metric) === null || _props$metricAssignme2 === void 0 ? void 0 : _props$metricAssignme2.unitName
          }
        },
        colors: ['#ababab', '#5188ff'],
        tooltip: {
          shared: true,
          followCursor: false,
          marker: {
            show: true
          },
          fixed: {
            position: 'topLeft'
          }
        },
        markers: {
          size: 4,
          colors: ['#ababab', '#5188ff'],
          strokeWidth: 2,
          strokeColors: '#FFFFFF',
          strokeOpacity: 1,
          hover: {
            sizeOffset: 2
          }
        },
        stroke: {
          width: 3
        },
        theme: {
          mode: 'light'
        }
      };
    });
    var hasValues = computed(function () {
      var _props$metricAssignme3, _props$metricAssignme4;
      return (_props$metricAssignme3 = props.metricAssignment) === null || _props$metricAssignme3 === void 0 ? void 0 : (_props$metricAssignme4 = _props$metricAssignme3.metricValues) === null || _props$metricAssignme4 === void 0 ? void 0 : _props$metricAssignme4.some(function (e) {
        return e.target !== null || e.actual !== null;
      });
    });
    var series = computed(function () {
      var _props$metricAssignme5;
      if (!props.metricAssignment) {
        return [];
      }
      var sortedValues = _toConsumableArray(((_props$metricAssignme5 = props.metricAssignment) === null || _props$metricAssignme5 === void 0 ? void 0 : _props$metricAssignme5.metricValues) || []).sort(function (a, b) {
        return Number(a.period) - Number(b.period);
      }).filter(function (v) {
        return v.target || v.actual;
      });
      return [{
        name: 'Target',
        data: sortedValues.map(function (e) {
          return {
            x: e.period,
            y: e.target
          };
        })
      }, {
        name: 'Actual',
        data: sortedValues.map(function (e) {
          return {
            x: e.period,
            y: e.actual
          };
        })
      }];
    });
    return {
      __sfc: true,
      props: props,
      chartOptions: chartOptions,
      hasValues: hasValues,
      series: series
    };
  }
});